<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { HTMLAttributes } from 'svelte/elements';

	const { children, ...rest }: HTMLAttributes<HTMLButtonElement> & { children: Snippet } = $props();
</script>

<button
	{...rest}
	class={[
		'group relative flex w-full cursor-pointer items-center gap-2 rounded-lg border border-neutral-400 bg-white p-2 text-left text-sm transition-colors hover:bg-neutral-800 hover:text-white',
		rest.class,
	]}
>
	{@render children()}
	<span class="icon-[mdi--chevron-down] ml-auto hidden sm:block"></span>
</button>
